@if (checkboxModel) {
  @for (cb of checkboxModel; track cb.key) {
    <div class="check-container" [ngClass]="{'disabled': disabled()}">
      <span class="material-icons check-icon" (click)="checkChange.emit(cb)">{{ cb.checked ? 'check_box' : 'check_box_outline_blank' }}</span>
      <div class="check-label"><span (click)="checkChange.emit(cb)">{{ cb.label }}</span>
        @if (cb.clickableLabelText) {
          <a class="check-link" (click)="clickLabel.emit(cb)">{{ cb.clickableLabelText }}</a>
        }</div>
    </div>
  }
}
